import _ from "lodash";

const getPriceValue = (price) => {
  if (!price || price.trim() === "") return 0;
  if (price === "included" || price === "free") return 0;
  const priceVal = parseFloat(price.trim().replace("$", ""));
  return isNaN(priceVal) ? 0 : priceVal;
};

export const getReportPriceDetails = (additionalData, reports) => {
  const reportIds = additionalData.reportIds;
  let reportBasePrice;
  if (
    additionalData &&
    additionalData.reportIds &&
    additionalData.reportIds.length > 0
  ) {
    reportBasePrice = _.filter(reports, (a) => a.ReportID === reportIds[0]);
  }
  const basePrice =
    reportBasePrice &&
    reportBasePrice.length > 0 &&
    reportBasePrice[0].SearchResultCost
      ? getPriceValue(reportBasePrice[0].SearchResultCost)
      : -1;
  const baseReportCount =
    reportBasePrice &&
    reportBasePrice.length > 0 &&
    reportBasePrice[0].NumberAtCost
      ? reportBasePrice[0].NumberAtCost
      : 0;
  let addPrice = -1;
  if (reportIds && reportIds.length > 1) {
    const reportsAddPrice = _.filter(
      reports,
      (a) => a.ReportID === reportIds[1]
    );
    addPrice =
      reportsAddPrice &&
      reportsAddPrice.length > 0 &&
      reportsAddPrice[0].SearchResultCost
        ? getPriceValue(reportsAddPrice[0].SearchResultCost)
        : -1;
  }
  return { basePrice, baseReportCount, addPrice };
};

export const getPriceMessage = (priceDetail) => {
  if (!priceDetail) return "";
  if (priceDetail.basePrice === 0 && priceDetail.addPrice === 0) {
    return "Included In Plan.";
  }
  if (priceDetail.baseReportCount === 0) {
    return `Select an unlimited number of reports to view for $${priceDetail.basePrice.toFixed(
      2
    )}`;
  }
  return `Select up to ${
    priceDetail.baseReportCount
  } reports to view for $${priceDetail.basePrice.toFixed(
    2
  )}. Each additional report only $${priceDetail.addPrice.toFixed(2)}`;
};

export default getReportPriceDetails;



// WEBPACK FOOTER //
// ./src/components/common/ReportPriceDetails.js